import { SET_NO_PERMISSION, SET_PAGE_META } from './types';

const initialState = {
  title: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PAGE_META:
      return { ...state, ...action.payload };
    case SET_NO_PERMISSION:
      return { ...state, noPermissionLicense: action.payload };
    default:
      return state;
  }
}
